import React from 'react';
import { Progress } from 'rebass';
import events from './manifest';
import _ from 'underscore';
import Select from 'react-select';
import ImageAssetModal from '../components/ImageAssetModal';
import path from 'ramda/src/path';
import { ChromePicker } from 'react-color';
import curry from 'ramda/src/curry';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router';

var steps = [
    'Roku channel store info',
    'Branding',
    'Support',
    'Confirm channel submission'
];

var views = [
    ChannelStoreInfo,
    Branding,
    Support,
    Confirm
];

function OttRoku (props) {

    return <div className="ott-roku">
        {/* tell people about billing */}
        <Modal bsSize="large" show={!!props.billingConfirmation}>
            <Modal.Header closeButton={false}>
                <Modal.Title>Roku channel setup</Modal.Title>
            </Modal.Header>

            <Modal.Body className="container-fluid">
                <div className="alert alert-info">
                    <p>You are confirming that Invintus will be creating an OTT channel for a one time fee of $1,000.</p>
                    <p>This fee will be billed to you through your regular payment method after the OTT channel is deployed and approved by Roku.</p>
                    <p>If you have any questions please email billing@invintus.com.</p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-primary"
                    onClick={_.compose(
                        props.push,
                        events.confirmBilling,
                        _.constant(null)
                    )}
                >
                    Continue
                </button>
            </Modal.Footer>
        </Modal>

        <ImageAssetModal
            show={!!props.isBrowsingImages}
            onHide={_.compose(
                props.push,
                events.closeImageModal,
                _.constant(null)
            )}
            onSelect={_.compose(
                props.push,
                events.selectImage
            )}
            assets={props.assets}
        />

        <RokuProgress {...props} />

        {views[props.activeStep](props)}
    </div>;
}

// OttRoku.propTpes = {
//     activeStep: pt.number.isRequired,
//     pendingEdits: pt.object.isRequired,
//     isBrowsingImages: pt.bool.isRequired
// };

function onFieldChange (props, key) {
    return _.compose(
        props.push,
        events.fieldChange,
        function (ev) {
            return {
                key: key,
                value: ev.target.value
            };
        }
    );
}

function ChannelStoreInfo (props) {
    return <div className="roku-channel-store">
        <div className="row">

            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="channelName">Roku channel name *</label>
                    <input className="form-control" type="text"
                        defaultValue={props.pendingEdits.channelName}
                        id="channelName"
                        onChange={onFieldChange(props, 'channelName')}
                    />
                </div>
            </div>

            <div className="col-sm-6">
                <label htmlFor="channelCategory">Preferred category *</label>
                <Select
                    id="channelCategory"
                    name="form-field-name"
                    value={props.pendingEdits.channelCategory}
                    options={catOptions()}
                    onChange={_.compose(
                        props.push,
                        events.selectCategory,
                        function (ev) {
                            return ev ? ev.value : null;
                        }
                    )}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="vanityString">Vanity access code</label>
                    <input className="form-control" type="text"
                        defaultValue={props.pendingEdits.vanityString}
                        id="vanityString"
                        onChange={onFieldChange(props, 'vanityString')}
                    />
                    <p className="help-block">https://my.roku.com/add/&lt;code&gt;</p>
                </div>
            </div>

            <div className="col-sm-6">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" name="ageRestriction"
                            defaultChecked={props.pendingEdits.ageRestriction}
                        /> Age restriction 13+
                    </label>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-sm-12">
                <div className="form-group">
                    <label
                        htmlFor="channelDescription"
                        className="char-limit"
                    >
                        Channel description *
                        <span className="char-counter">
                            {(props.pendingEdits.channelDescription || '').length + ' / 300'}
                        </span>
                    </label>
                    <textarea className="form-control"
                        id="channelDescription"
                        rows="3"
                        value={props.pendingEdits.channelDescription || ''}
                        onChange={changeText(props, 'channelDescription')}
                    ></textarea>
                    <p className="help-block">300 characters max. A detailed description of the channel you are adding. This detail will appear in the Channel Store description of your channel.</p>
                </div>
            </div>

            <div className="col-sm-12">
                <div className="form-group">
                    <label htmlFor="webDescription"
                        className="char-limit"
                    >
                        Web description *
                        <span className="char-counter">
                            {(props.pendingEdits.webDescription || '').length + ' / 1500'}
                        </span>
                    </label>
                    <textarea className="form-control" id="webDescription"
                        value={props.pendingEdits.webDescription || ''}
                        onChange={changeText(props, 'webDescription')}
                        rows="3"></textarea>
                    <p className="help-block">You may enter a channel description up to 1500 characters. This channel description may be used for U.S. web based marketing of your channel. It will not display on the device.</p>
                </div>
            </div>

            <div className="col-sm-6">
                <label>Channel poster *</label>
                {ImageError('540 × 405', validDimensions.channelPoster(props))}
                <button className="btn btn-default btn-lg btn-block"
                    onClick={browseImages(props, 'channelPoster')}
                >
                    Add image
                </button>
                <p className="help-block">540 × 405 jpeg/png</p>
                <p className="help-block">This image will display in the Roku Channel Store.</p>

                {props.pendingEdits.channelPoster ?
                    <img
                        src={_(props.assets.data).findWhere({
                            assetID: props.pendingEdits.channelPoster.assetID
                        }).fileUrl}
                        className="img-responsive"
                    /> :
                    null
                }
            </div>

        </div>
    </div>;
}

function ImagePreview (props, key) {
    return props.pendingEdits[key] ?
        <img
            src={_(props.assets.data).findWhere({
                assetID: props.pendingEdits[key].assetID
            }).fileUrl}
            className="img-responsive"
        /> :
        null
    ;
}

var dimensionsOk = curry(function (key, w, h, props) {
    var asset = _(props.assets.data).findWhere({
        assetID: path(['pendingEdits', key, 'assetID'], props)
    });
    var details = path(['advancedDetails', 'image', 0], asset);
    if (!details) return true; // image is not set, so don't show warning
    return (details.height == h && details.width == w);
});

var validDimensions = {
    channelPoster: dimensionsOk('channelPoster', 540, 405),
    channelLogo: dimensionsOk('channelLogo', 400, 90),
    splashScreen: dimensionsOk('splashScreen', 1920, 1080),
    smallLogo: dimensionsOk('smallLogo', 165, 60),
    backgroundImage: _.constant(true) // roku doesn't have specs for this
};

function allDimensionsOk (props) {
    return Object.keys(validDimensions).reduce(function (acc, k) {
        return acc && validDimensions[k](props);
    }, true);
}

function brandingIsValid (props) {
    return _(Object.keys(validDimensions)).without('channelPoster')
        .reduce(function (acc, k) {
            return acc && validDimensions[k](props);
        }, true)
    ;
}

function ImageError (msg, isValid) {
    return isValid ?
        null :
        <span className="text-danger image-error">
            Image size should be {msg}
        </span>
    ;
}


function Branding (props) {
    return <div className="roku-branding">
        <div className="row">

            <div className="col-sm-6">
                <label>Channel logo *</label>
                {props.pendingEdits.channelLogo ?
                    ImageError('400 × 90', validDimensions.channelLogo(props)) :
                    null
                }
                <button className="btn btn-default btn-lg btn-block"
                    onClick={browseImages(props, 'channelLogo')}
                >
                    Add image
                </button>
                <p className="help-block">400 × 90 jpeg/png</p>
                <p className="help-block">The Channel Logo will display inside your channel</p>
                {ImagePreview(props, 'channelLogo')}
            </div>

            <div className="col-sm-6">
                <label>Splash screen *</label>
                {props.pendingEdits.splashScreen ?
                    ImageError('1920 × 1080', validDimensions.splashScreen(props)) :
                    null
                }
                <button className="btn btn-default btn-lg btn-block"
                    onClick={browseImages(props, 'splashScreen')}
                >
                    Add image
                </button>
                <p className="help-block">1920 × 1080 jpeg/png</p>
                <p className="help-block">The Splash Screen displays while your channel is loading</p>
                {ImagePreview(props, 'splashScreen')}
            </div>
        </div>

        <hr/>

        <div className="row">
            <div className="col-sm-6">
                <label>Small logo *</label>
                {props.pendingEdits.smallLogo ?
                    ImageError('165 × 60', validDimensions.smallLogo(props)) :
                    null
                }
                <button className="btn btn-default btn-lg btn-block"
                    onClick={browseImages(props, 'smallLogo')}
                >
                    Add image
                </button>
                <p className="help-block">165 × 60 jpeg/png</p>
                <p className="help-block">The Small logo displays within Roku Search as a button to play your content</p>
                {ImagePreview(props, 'smallLogo')}
            </div>

            <div className="col-sm-6">
                <label>Background image *</label>
                <button className="btn btn-default btn-lg btn-block"
                    onClick={browseImages(props, 'backgroundImage')}
                >
                    Add image
                </button>
                <p className="help-block">The background image or color of your channel. If you specify a background image, you may also specify an overlay color which will be applied at 80% opacity over your image.</p>
                {ImagePreview(props, 'backgroundImage')}
            </div>
        </div>

        <hr/>

        <div className="row">
            <div className="col-sm-6">
                <label>Background color</label>
                <ChromePicker
                    color={props.pendingEdits.backgroundColor}
                    disableAlpha={true}
                    onChangeComplete={_.compose(
                        props.push,
                        events.changeBackgroundColor
                    )}
                />
                <p className="help-block">An overlay color which will be applied at 80% opacity over your image</p>
            </div>

            <div className="col-sm-6 bgc-preview">
                <div
                    className="bgc-preview-color"
                    style={{
                        backgroundColor: props.pendingEdits.backgroundColor
                    }}
                >
                </div>
            </div>

        </div>

    </div>;
}

function Support (props) {
    return <div className="roku-support">
        <div className="h4">Contact</div>
        <p className="help-block">
            If Roku customer service is contacted by an end user about your channel, to whom should we direct them?
        </p>

        <div className="row">

            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="supportName">Name *</label>
                    <input className="form-control" type="text" id="supportName"
                        defaultValue={props.pendingEdits.supportName}
                        onChange={onFieldChange(props, 'supportName')}
                    />
                </div>
            </div>

            <div className="col-sm-6">
                <div className={'form-group ' + (
                    (props.pendingEdits.supportPhone &&
                    !props.support.isValid.phone) ?
                        'has-error' :
                        ''
                )}>
                    <label htmlFor="supportPhone">Phone *</label>
                    <input
                        className="form-control"
                        type="tel"
                        id="supportPhone"
                        placeholder="555-555-5555"
                        value={props.pendingEdits.supportPhone || ''}
                        onChange={_.compose(
                            props.push,
                            events.phoneChange,
                            path(['target', 'value'])
                        )}
                    />
                </div>
            </div>

            <div className="col-sm-6">
                <div className={'form-group ' + (
                    (props.pendingEdits.supportUrl &&
                    !props.support.isValid.url) ?
                        'has-error' :
                        ''
                )}>
                    <label htmlFor="supportUrl">URL *</label>
                    <input className="form-control" type="url" id="supportUrl"
                        defaultValue={props.pendingEdits.supportUrl}
                        onChange={onFieldChange(props, 'supportUrl')}
                        placeholder="http://example.com"
                    />
                    <p className="help-block">This link may appear on the Roku website or in the Roku newsletter, and should feature information about this channel.</p>
                </div>
            </div>

            <div className="col-sm-6">
                <div className={'form-group ' + (
                    (props.pendingEdits.supportEmail &&
                    !props.support.isValid.email) ?
                        'has-error' :
                        ''
                )}>
                    <label htmlFor="supportEmail">Email *</label>
                    <input className="form-control" type="email" id="supportEmail"
                        type="email"
                        defaultValue={props.pendingEdits.supportEmail}
                        onChange={onFieldChange(props, 'supportEmail')}
                        placeholder="name@example.com"
                    />
                </div>
            </div>
        </div>

    </div>;
}

function NoData () {
    return <em style={{ color: 'gray' }}>none</em>;
}

function Confirm (props) {
    var info = [
        ['channelName', 'Channel name'],
        ['vanityString', 'Vanity access code'],
        ['channelCategory', 'Channel category'],
        ['channelDescription', 'Channel description'],
        ['webDescription', 'Web description']
    ];

    var support = [
        ['supportName', 'Name'],
        ['supportPhone', 'Phone'],
        ['supportEmail', 'Email'],
        ['supportUrl', 'URL']
    ];

    var getAsset = function (key, props) {
        return _(props.assets.data).findWhere({
            assetID: path(['pendingEdits', key, 'assetID'], props)
        });
    };

    var getImageSrc = _.compose(
        path(['fileUrl']),
        getAsset
    );

    function SummaryImage (props) {
        return <div className="summary-image-wrapper">
            {props.src ?
                (<img className="img-responsive" src={props.src} alt="" />) :
                <div style={{
                    height: '100%',
                    backgroundColor: 'white',
                    textAlign: 'center',
                    paddingTop: '50px'
                }}>
                    {props.children || <NoData />}
                </div>
            }
        </div>;
    }

    function EditAStep (props) {
        return <button className="btn btn-link" onClick={props.onClick}>
            edit
        </button>;
    }

    return <div className="ott-summary">
        <hr style={{ borderTop: '1px solid white' }}/>

        <div className="form-summary-list">
            <div className="h4">
                Channel store info
                <EditAStep
                    onClick={_.compose(
                        props.push,
                        events.changeStep,
                        _.constant(0)
                    )}
                />
            </div>
            <dl className="dl-horizontal">
                {_.flatten(info.map(function (pair, i) {
                    return [
                        <dt key={'dt' + i}>{pair[1]}</dt>,
                        <dd key={'dd' + i}>
                            {(props.pendingEdits[pair[0]] || <NoData />)}
                        </dd>
                    ];
                }))}
            </dl>

            <div className="row">
                <div className="col-sm-4">
                    <label>Channel poster</label>
                    <SummaryImage {...props} key={info.length}
                        src={getImageSrc('channelPoster', props)}
                    />
                </div>
            </div>
        </div>

        <hr style={{ borderTop: '1px solid white' }}/>

        <div className="form-summary-list row">
            <div className="h4 col-sm-12">
                Branding
                <EditAStep
                    onClick={_.compose(
                        props.push,
                        events.changeStep,
                        _.constant(1)
                    )}
                />
            </div>

            <div className="col-sm-4 ott-summary-image">
                <div className="h5">Channel logo</div>
                <SummaryImage {...props}
                    src={getImageSrc('channelLogo', props)}
                />
            </div>

            <div className="col-sm-4 ott-summary-image">
                <div className="h5">Splash screen</div>
                <SummaryImage {...props}
                    src={getImageSrc('splashScreen', props)} />
            </div>

            <div className="col-sm-4 ott-summary-image">
                <div className="h5">Small logo</div>
                <SummaryImage {...props}
                    src={getImageSrc('smallLogo', props)}
                />
            </div>

            <div className="col-sm-4 ott-summary-image">
                <div className="h5">Background image</div>
                <SummaryImage {...props}
                    src={getImageSrc('backgroundImage', props)}
                />
            </div>

            <div className="col-sm-4">
                <div className="h5">Background color</div>
                <div style={{ color: 'gray', height: '200px' }}>
                    <div style={{
                        height: '100%',
                        backgroundColor: props.pendingEdits.backgroundColor,
                        textAlign: 'center',
                        paddingTop: '50px'
                    }}></div>
                </div>
            </div>

        </div>

        <hr style={{ borderTop: '1px solid white' }}/>

        <div className="form-summary-list">
            <div className="h4">
                Contact
                <EditAStep
                    onClick={_.compose(
                        props.push,
                        events.changeStep,
                        _.constant(2)
                    )}
                />
            </div>
            <dl className="dl-horizontal">
                {_.flatten(support.map(function (pair, i) {
                    return [
                        <dt key={'dt' + i}>{pair[1]}</dt>,
                        <dd key={'dd' + i}>
                            {(props.pendingEdits[pair[0]] || <NoData />)}
                        </dd>
                    ];
                }))}
            </dl>
        </div>

    </div>;
}

function RokuProgress (props) {
    var validations = [
        validDimensions.channelPoster(props), // basic info
        brandingIsValid(props)
    ];
    const history = useHistory()
    const returnToListing = () => {
        history.push('/manage/ott')
    }

    return <div className="ott-progress">
        <h1 className="h3">{steps[props.activeStep]}</h1>

        <Progress
            color="primary"
            value={props.activeStep / (steps.length - 1)}
        />

        <ul className="list-inline list-unstyled text-right">
            <li>
                <button className="btn btn-default"
                    disabled={props.activeStep === 0}
                    onClick={_.compose(
                        props.push,
                        events.prevStep,
                        _.constant(null)
                    )}
                >
                    Back
                </button>
            </li>

            {props.activeStep === (steps.length - 1) ?
                <li>
                    <button className="btn btn-success"
                        disabled={!(
                            _.every(props.stepIsValid) &&
                            allDimensionsOk(props)
                        )}
                        onClick={_.compose(
                            props.push,
                            events.saveJob,
                            returnToListing
                        )}
                    >
                        Save
                    </button>
                </li> :

                <li>
                    <button className="btn btn-primary"
                        disabled={!(
                            props.stepIsValid[props.activeStep] &&
                            (validations[props.activeStep] !== undefined ?
                                validations[props.activeStep] :
                                true)
                        )}
                        onClick={_.compose(
                            props.push,
                            events.nextStep,
                            _.constant(null)
                        )}
                    >
                        Next
                    </button>
                </li>
            }
        </ul>
    </div>;
}


export default OttRoku;

function changeText (props, key) {
    return _.compose(
        props.push,
        events.changeText,
        function (ev) {
            return {
                key: key,
                value: ev.target.value
            };
        }
    );
}

function browseImages (props, key) {
    return _.compose(
        props.push,
        events.browseImages,
        function (ev) {
            ev.preventDefault();
            return key;
        }
    );
}

// verbosity
function catOptions () {
    var opts = [
        'Apps',
        'Comedy',
        'Educational',
        'Fitness',
        'Food',
        'Games',
        'International',
        'Kids & Family',
        'Lifestyle',
        'Movies & TV',
        'Music',
        'News & Weather',
        'Personal Media',
        'Photo Apps',
        'Religious',
        'Sci & Tech',
        'Screensavers',
        'Shopping',
        'Special Interest',
        'Sports',
        'Themes',
        'Travel',
        'Web Video',
        'TV Everywhere'
    ];

    return opts.map(function (opt) {
        return {
            value: opt,
            label: opt
        };
    });
}
